// extracted by mini-css-extract-plugin
export default {"indochine":"#cf7800","news":"K","welcome":"L"};